import { db, sessionsRef } from "@/main.js";
import { doc, updateDoc } from "firebase/firestore";
import { uploadBytes, getDownloadURL, ref } from "firebase/storage";
import { collection, addDoc, getDocs, query, where, orderBy, onSnapshot, deleteDoc } from "firebase/firestore";

const state = {
  events2025: [],
  events2026: [],
  offer: [
    {
      title: "Motocyklowa",
      route: "oferta/fotografia-motocyklowa",
      pricing: {
        title: "Fotografia motocyklowa",
        text: "",
        // 'Oferta skierowana jest do osób, dla których jazda motocyklem jest pasją. Fotografuję motocyklistów na krętych widokowych drogach Polski południowej i Czech. W oferuję zdjęcia w dużej rozdzielczości przesyłane klientowi w wersji elektronicznej.<br><br>MAKSYMALNY ROZMIAR ZDJĘCIA - 9192x6464 / WIELKOŚĆ - 24,5 MG<br><br><div class="text-h6 black--text">Cennik</div>1 zdjęcie - 26,00 zł<br>2 zdjęcia - 42,00 zł<br>3 zdjęcia - 54,00 zł<br>4 zdjęcia - 64,00 zł<br>5 zdjęć - 70,00 zł<br>6 zdjęć - 78,00 zł<br>7 zdjęć - 84,00 zł<br>8 zdjęć - 88,00 zł<br>9 zdjęć - 90,00 zł<br>10 zdjęć - 100,00 zł<br>11 zdjęć - 110,00 zł<br>12 zdjęć - 120,00 zł<br>13 zdjęć - 130,00 zł<br>14 zdjęć - 140,00 zł<br>15 zdjęć - 150,00 zł<br>16 zdjęć - 160,00 zł<br>17 zdjęć - 170,00 zł<br>18 zdjęć - 180,00 zł<br>19 zdjęć - 190,00 zł<br>20 zdjęć - 200,00 zł<br>30 zdjęć - 270,00 zł<br>40 zdjęć - 320,00 zł<br><br>Zdjęcia w dwóch, trzy dni po sesji dostępne są po przez link, do obejrzenia w galeriach fotograficznych w zakładce SESJE MOTOCYKLOWE oraz na facebooku MotoKadr.com<br><br>Po wybraniu zdjęć, zamówienie z datą sesji i numerami zdjęć ( wystarczą ostatnie cztery cyfry ), proszę przesłać na e-mail: moto.kadr@gmail.com lub na skrzynkę odbiorczą ( Messenger ) facebook MotoKadr.com.<br><br><div class="text-h6 black--text">Sesje indywidualne</div>Ciekawa propozycja na prezent np. urodzinowy.<br>Od 30 do 35 profesjonalnych zdjęć w wersji elektronicznej<br>Czas sesji 1-2 godziny.<br>Cena za sesję 350 zł.<br><br>Miejsce sesji fotograficznej wybiera klient.<br>W ciągu 3 dni zdjęcia w pełnej rozdzielczości są gotowe i przesłane w formie elektronicznej na wskazany adres e-mail.<br><br><span class="text-h6 black--text">Sesje grupowe</span><br>Oferta skierowana jest do zorganizowanych grup i osób wspólnie spędzających czas na motocyklach.<br>Cena za sesję jest ustalana indywidualnie w zależności od liczby uczestników, ilości zdjęć i miejsca sesji.<br><br><div class="text-h6 black--text">Format i cennik fotoobrazów:</div>30x20 / 20x30 - 130 zł<br>40x30 / 30x40 - 150 zł<br>40x40 - 160 zł<br>50x40 / 40x50 - 160 zł<br>50x50cm - 170 zł<br>60x40 / 50x60 - 170 zł<br>60x60 - 185 zł<br>60x20 / 20x60 - 155 zł<br>70x50 / 50x70 - 190 zł<br>70x70 - 205 zł<br>80x60 / 60x80 - 205 zł<br>90x60 / 60x90 - 215 zł<br>90x30 / 30x90 - 190 zł<br>100x70 / 70x100 - 220 zł<br>110x80 / 80x110 - 230 zł<br>120x80 / 80x120 - 245 zł<br>150x100 / 100x150 - 280 zł<br><div class="font-weight-bold black--text">UWAGA!!! Przy zamówieniu fotoobrazu bardzo proszę o podanie w mailu dokładnego adresu do wysyłki i numeru telefonu dla kuriera.</div><br><br><div class="text-h6 black--text">Format fotoksiążek</div>A4 PION (21x29,5cm) minimum 28 stron - 200 zł<br>A4 POZIOM (29,5x21cm) minimum 28 stron - 200 zł<br>A3 POZIOM (42x29,5cm) minimum 28 stron - 330 zł<br><br>Twarda okładka z laminatem błyszczącym.<br>Kredowy papier o gramaturze 200 g/m2.<br>Od 28 do 160 stron.<br><br><div class="text-h6 black--text">Formaty i cennik zdjęć</div>Papier „PRO” błyszczący lub matowy.<br>20x30 - minimum 3 sztyki - 70 zł wraz z przesyłką.<br>15x21 - minimum 20 sztuk - 90 zł wraz z przesyłką.<br><br>Zdjęcia XXL papier półmat:<br>40x30 - 80 zł<br>60x40 - 110 zł<br>70x50 - 135 zł<br>80x60 - 165 zł<br>100x70 - 185 zł<br><br><img style="max-width: 100%" src="./assets/fotoksiazki/1J4A7730.jpg"/><img style="max-width: 100%" src="./assets/fotoksiazki/1J4A6760-HDR.jpg"/><img style="max-width: 100%" src="./assets/fotoksiazki/1J4A7737.jpg"/><img style="max-width: 100%" src="./assets/fotoksiazki/1J4A7832-HDR.jpg"/><br><br><span class="text-h6 black--text">Płatności:</span><br>Informacje dotyczące numeru konta znajdują się w zakładce kontakt. W tytule przelewu proszę wpisać „ Zamówienie, numer pierwszego zdjęcia i adres e-mail” Po zaksięgowaniu wpłaty na koncie bankowym, zdjęcia / link do zdjęć / wysłane zostaną na wskazany adres e-mail.<br><br><span class="text-h6 black--text">Dodatkowe informacje</span><br>Dojazd na miejsce sesji w okolicach Jeleniej Góry do 30 km bezpłatny.<br>Zdjęcia poddawane są obróbce w programie graficznym ( poprawa kolorów, balansu bieli, kontrast, kadrowanie itp )<br>W ciągu 3 dni gotowe zdjęcia przesłane są klientowi w wersji elektroniczne na wskazany adres e-mail.<br>W celu uzyskania szczegółowych informacji o produkcje i cenniku proszę o kontakt telefoniczny pod numer 664 466 684 lub e-mail moto.kadr@gmail.com',
        paragraphs: [
          {
            title: "Cennik",
            content: `1 zdjęcie - 29 zł<br>
              2 zdjęcia - 50 zł<br>
              3 zdjęcia - 69 zł<br>
              4 zdjęcia - 88 zł<br>
              5 zdjęć - 105 zł<br>
              6 zdjęć - 120 zł<br>
              7 zdjęć - 133 zł<br>
              8 zdjęć - 144 zł<br>
              9 zdjęć - 153 zł<br>
              10 zdjęć - 160 zł<br>
              11 zdjęć - 166 zł<br>
              12 zdjęć - 172 zł<br>
              13 zdjęć - 178 zł<br>
              14 zdjęć - 184 zł<br>
              15 zdjęć - 190 zł<br>
              16 zdjęć - 196 zł<br>
              17 zdjęć - 202 zł<br>
              18 zdjęć - 208 zł<br>
              19 zdjęć - 214 zł<br>
              20 zdjęć - 220 zł<br>
              30 zdjęć - 300 zł<br>
              40 zdjęć - 390 zł<br><br>
              Sesja indywidualna 30-35 zdjęć 500 zł<br>
              Szczegółowe informacje o sesjach indywidualnych - kontakt telefoniczny <span class="secondary--text">664 466 684</span><br><br>
              Zamówienia można składać drogą mailową na e-mail <span class="secondary--text">moto.kadr@gmail.com</span> oraz na instagramie <a href="https://www.instagram.com/motokadrcom/#" target="_blank" style="text-decoration: none;" class="secondary--text">@motokadrcom</a><br>
              W razie pytań proszę o kontakt telefoniczny <span class="secondary--text">664 466 684</span><br>
              Po wybraniu zdjęć ( proszę o podanie daty z jakiego dnia jest galeria i numery zdjęć - wystarczą ostatnie cztery cyfry numeru zdjęcia ), proszę następnie przesłać na mail <span class="secondary--text">moto.kadr@gmail.com</span><br><br>`,
          },
          {
            title: "Płatności na konto",
            content: `Violetta Wojtowicz<br>
              Numer konta: <span class="secondary--text">11 1020 2124 0000 8502 0028 6815</span><br>
              <div class="font-weight-bold black--text">UWAGA !!!!!!!!!!!</div>
              Bardzo proszę w  tytule przelewu proszę wpisać: <br>
              <ul>
              <li>Numer pierwszego zdjęcia</li>
              <li>Z jakiego jest dnia</li>
              <li>Jeśli to możliwe wpisać adres e-mail</li>
              </ul><br>
              Po zaksięgowaniu wpłaty na koncie bankowym, zdjęcia / link do zdjęć wysłane zostaną na wskazany adres e-mail.<br><br>
              Kod BIC (Swift) banku: <span class="secondary--text">BPKOPLPW</span><br>
              Kod IBAN: <span class="secondary--text">PL 11102021240000850200286815</span><br><br>`,
          },
          {
            title: "Sesje grupowe",
            content:
              "Oferta skierowana jest do zorganizowanych grup i osób wspólnie spędzających czas na motocyklach.<br>Cena za sesję jest ustalana indywidualnie w zależności od liczby uczestników, ilości zdjęć i miejsca sesji.<br><br>",
          },
          {
            title: "Format i cennik fotoobrazów:",
            content: `30x20 / 20x30 - 127 zł<br>
            30x30 - 135 zł<br>
            40x30 / 30x40 - 150 zł<br>
            45x30 / 30x45 - 160 zł<br>
            40x40 - 165 zł<br>
            50x40 / 40x50 - 170 zł<br>
            50x50cm - 180 zł<br>
            60x40 / 40x60 - 190 zł<br>
            60x60 - 200 zł<br>
            60x20 / 20x60 - 182 zł<br>
            70x50 / 50x70 - 210 zł<br>
            70x70 - 220 zł<br>
            80x60 / 60x80 - 230 zł<br>
            90x60 / 60x90 - 240 zł<br>
            90x30 / 30x90 - 220 zł<br>
            100x70 / 70x100 - 270 zł<br>
            110x80 / 80x110 - 290 zł<br>
            120x80 / 80x120 - 300 zł<br>
            130x90 / 90x130 - 320 zł<br>
            150x100 / 100x150 - 360 zł<br>
            Do ceny należy doliczyć 20 - 30 zł koszt przesyłki w zależności od wielkości formatu fotoobrazu<br><br>
            <div class="font-weight-bold black--text">UWAGA!!! Przy zamówieniu fotoobrazu bardzo proszę o podanie w mailu dokładnego adresu do wysyłki i numeru telefonu dla kuriera.</div><br><br>`,
          },
          {
            title: "Format i cennik fotoksiążek",
            content: `Twarda okładka z laminatem błyszczącym lub matowym (w cenie twarda okładka z laminatem błyszczącym).<br>
            Kredowy papier o gramaturze 200 g/m2.<br>
            Od 28 do 160 stron.<br><br>
            A4 PION (21x29,5cm) minimum 28 stron - 195 zł (<b>+ 1,50 zł</b> za każdą kolejną stronę)<br>
            A4 POZIOM (29,5x21cm) minimum 28 stron - 195 zł (<b>+ 1,50 zł</b> za każdą kolejną stronę)<br>
            A3 POZIOM (42x29,5cm) minimum 28 stron - 250 zł (<b>+ 1,50 zł</b> za każdą kolejną stronę)<br><br>
            Koszt przesyłki 20 zł<br><br>`,
          },
          {
            title: "Duże formaty zdjęć",
            content: `30x40 / 40x30 - 95 zł<br>
            40X60 / 60X40 - 116 zł<br>
            50X70 / 70X50 - 125 zł<br>
            60X80 / 80X60 - 145 zł<br>
            70X100 / 100X70 - 175 zł<br><br>
            Papier satynowy półmatowy<br>
            Koszt przesyłki 20 zł<br><br>`,
          },
          {
            title: "Zdjęcia",
            content: `10x15 minimum 10 odbitek - 25 zł<br>
            9x13 minimum 20 odbitek - 62 zł<br>
            10x10 minimum 20 odbitek - 62 zł<br>
            13x13 minimum 20 odbitek - 68 zł<br>
            13x18 minimum 20 odbitek - 72 zł<br>
            15x21 minimum 20 odbitek - 80 zł<br>
            20x30 minimum 3 odbitki - 57 zł<br><br>
            Papier premium błyszczący i matowy.<br><br>`,
            imageRow: true,
          },
          {
            title: "Dodatkowe informacje",
            content: `Dojazd na miejsce sesji w okolicach Jeleniej Góry do 30 km bezpłatny.<br>
            Zdjęcia poddawane są obróbce w programie graficznym ( poprawa kolorów, balansu bieli, kontrast, kadrowanie itp )<br>
            W ciągu 3 dni gotowe zdjęcia przesłane są klientowi w wersji elektroniczne na wskazany adres e-mail.<br>
            W celu uzyskania szczegółowych informacji o produkcje i cenniku proszę o kontakt telefoniczny pod numerem <span class="secondary--text">664 466 684</span> lub e-mail <span class="secondary--text">moto.kadr@gmail.com</span>`,
          },
        ],
      },
      imageUrl: "./assets/backimg.jpg",
      galleryUrls: [
        "./assets/environment/1J4A8232.jpg",
        "./assets/environment/IP5A7383-2.jpg",
        "./assets/environment/1AJ452452.jpg",
        "./assets/motocykle/1J4A0998.jpg",
        "./assets/motocykle/1J4A1338.jpg",
        "./assets/motocykle/1J4A1677.jpg",
        "./assets/motocykle/1J4A1810.jpg",
        "./assets/motocykle/1J4A2165.jpg",
        "./assets/motocykle/1J4A2229.jpg",
        "./assets/motocykle/1J4A2458.jpg",
        "./assets/motocykle/1J4A2495.jpg",
        "./assets/motocykle/1J4A2608.jpg",
        "./assets/motocykle/1J4A2710.jpg",
        "./assets/motocykle/1J4A2793.jpg",
        "./assets/motocykle/1J4A2841.jpg",
        "./assets/motocykle/1J4A3000.jpg",
        "./assets/motocykle/1J4A3007.jpg",
        "./assets/motocykle/1J4A3012.jpg",
        "./assets/motocykle/1J4A3045.jpg",
        "./assets/motocykle/1J4A3047.jpg",
        "./assets/motocykle/1J4A3049.jpg",
        "./assets/motocykle/1J4A3062.jpg",
        "./assets/motocykle/1J4A3082.jpg",
        "./assets/motocykle/1J4A3093.jpg",
        "./assets/motocykle/1J4A3111.jpg",
        "./assets/motocykle/1J4A3143.jpg",
        "./assets/motocykle/1J4A3252.jpg",
        "./assets/motocykle/1J4A3270.jpg",
        "./assets/motocykle/1J4A3276.jpg",
        "./assets/motocykle/1J4A3297.jpg",
        "./assets/motocykle/1J4A3303.jpg",
        "./assets/motocykle/1J4A3336.jpg",
        "./assets/motocykle/1J4A3346.jpg",
        "./assets/motocykle/1J4A3349.jpg",
        "./assets/motocykle/1J4A3362.jpg",
        "./assets/motocykle/1J4A3374.jpg",
        "./assets/motocykle/1J4A3377.jpg",
        "./assets/motocykle/1J4A3385.jpg",
        "./assets/motocykle/1J4A3395.jpg",
        "./assets/motocykle/1J4A3398.jpg",
        "./assets/motocykle/1J4A3406.jpg",
        "./assets/motocykle/1J4A3415.jpg",
        "./assets/motocykle/1J4A3423.jpg",
        "./assets/motocykle/1J4A3437.jpg",
        "./assets/motocykle/1J4A3493.jpg",
        "./assets/motocykle/1J4A3524.jpg",
        "./assets/motocykle/1J4A3525.jpg",
        "./assets/motocykle/1J4A3556.jpg",
        "./assets/motocykle/1J4A3569.jpg",
        "./assets/motocykle/1J4A3727.jpg",
        "./assets/motocykle/1J4A3976.jpg",
        "./assets/motocykle/1J4A4114.jpg",
        "./assets/motocykle/1J4A4236.jpg",
        "./assets/motocykle/1J4A4334.jpg",
        "./assets/motocykle/1J4A4381.jpg",
        "./assets/motocykle/1J4A4502.jpg",
        "./assets/motocykle/1J4A4930.jpg",
        "./assets/motocykle/1J4A5174.jpg",
        "./assets/motocykle/1J4A5321.jpg",
        "./assets/motocykle/1J4A5627.jpg",
        "./assets/motocykle/1J4A5715.jpg",
        "./assets/motocykle/1J4A5803.jpg",
        "./assets/motocykle/1J4A5812.jpg",
        "./assets/motocykle/1J4A5917.jpg",
        "./assets/motocykle/1J4A5943.jpg",
        "./assets/motocykle/1J4A5950.jpg",
        "./assets/motocykle/1J4A5963.jpg",
        "./assets/motocykle/1J4A6251.jpg",
        "./assets/motocykle/1J4A6808.jpg",
        "./assets/motocykle/1J4A6980.jpg",
        "./assets/motocykle/1J4A7745.jpg",
        "./assets/motocykle/1J4A7821.jpg",
        "./assets/motocykle/1J4A7863.jpg",
        "./assets/motocykle/1J4A7923.jpg",
        "./assets/motocykle/1J4A7986.jpg",
        "./assets/motocykle/1J4A8340.jpg",
        "./assets/motocykle/1J4A8587.jpg",
        "./assets/motocykle/1J4A8770.jpg",
        "./assets/motocykle/1J4A8833.jpg",
        "./assets/motocykle/1J4A9028.jpg",
        "./assets/motocykle/1J4A9194.jpg",
        "./assets/motocykle/1J4A9256.jpg",
        "./assets/motocykle/1J4A9304.jpg",
        "./assets/motocykle/1J4A9413.jpg",
        "./assets/motocykle/1J4A9417.jpg",
        "./assets/motocykle/1J4A9465.jpg",
        "./assets/motocykle/DSCF1674.jpg",
      ],
      description:
        // "Wieloletnia pasja do fotografii i turystyki motocyklowej zaowocowała pomysłem na fotografię motocyklową. <br><br>Fotografuję motocyklistów na krętych widokowych drogach Polski południowej i Czech. Informacje o sesjach fotograficznych odbywających się głównie w weekendy ( czas i miejsce ), zamieszczam z dwu-trzydniowym wyprzedzeniem, w zakładce „NADCHODZĄCE WYDARZENIA” i na facebook Moto.Kadr w formie postu. <br><br>W ofercie profesjonalne zdjęcia w dużej rozdzielczości w wersji elektronicznej. FOTOOBRAZY  i  ZDJĘCIA W DUŻYCH FORMATACH. <br><br>Fotoobrazy wykonany z wysokiej jakości płótna canvas na sosnowej ramce malarskiej.<br>Formaty od 40x30 do 150x100cm. <br>W komplecie zawieszka do montażu na ścianie. <br>Zdjęcia na papierze błyszczącym i półmatowym - duży wybór formatów.",
        "Oferta skierowana jest do osób, dla których jazda motocyklem jest pasją. Fotografuję motocyklistów w Karkonoszach na drodze krajowej nr 3, zwanej „Szosą Czeską” między Szklarską Porębą a Jakuszycami. Fotografuje również po  Czeskiej stronie Karkonoszy, na drodze nr 44 na przełęczy „Cervenohorskie Sedlo” oraz na drodze nr 11 Cervena Voda - Jablonne nad Orlici. W oferuję zdjęcia w dużej rozdzielczości przesyłane klientowi w wersji elektronicznej.",
      text:
        "Wieloletnia pasja do fotografii i turystyki motocyklowej zaowocowała pomysłem na fotografię motocyklową. Fotografuję motocyklistów na krętych widokowych drogach Polski południowej i Czech...",
    },
    {
      title: "Sportowa",
      route: "oferta/fotografia-sportowa",
      pricing: {
        title: "Fotografia sportowa",
        text: "",
        // '<div class="text-h6 black--text">Cennik</div>1 zdjęcie - 22,00 zł<br>2 zdjęcia - 35,00 zł<br>3 zdjęcia - 40,00 zł<br>4 zdjęcia - 45,00 zł<br>5 zdjęć - 50,00 zł<br>6 zdjęć - 60,00 zł<br>7 zdjęć - 70,00 zł<br>8 zdjęć - 80,00 zł<br>9 zdjęć - 90,00 zł<br>10 zdjęć - 100,00 zł<br>11 zdjęć - 107,00 zł<br>12 zdjęć - 114,00 zł<br>13 zdjęć - 121,00 zł<br>14 zdjęć - 128,00 zł<br>15 zdjęć - 135,00 zł<br>16 zdjęć - 142,00 zł<br>17 zdjęć - 149,00 zł<br>18 zdjęć - 156,00 zł<br>19 zdjęć - 163,00 zł<br>20 zdjęć - 170,00 zł<br>Powyżej 20 zdjęć cena do negocjacji.<br><br><div class="text-h6 black--text">Sesje indywidualne</div>Zawodnicy lub osoby ich reprezentujące, mogą zamówić sesję indywidualną z każdego startu na danych zawodach. Wówczas skupiam się na danym zawodniku i fotografuje każdy jago start i przejazd.<br>CENA ZA TAKĄ SESJĘ JEST USTALANA INDYWIDUALNIE Z KAŻDYM KLIENTEM, W ZALEŻNOŚCI OD LICZBY ZDJĘĆ.<br>CENA ZA FOTOREPORTAŻ Z CAŁEJ IMPREZY JEST USTALANA INDYWIDUALNIE Z KAŻDYM KLIENTEM, W ZALEŻNOŚCI LICZBY ZDJĘĆ I CZASU TRWANIA SESJI.<br>Zdjęcia poddawane są obróbce w programie graficznym (poprawa kolorów, balansu bieli, kontrast, kadrowanie itp) W ciągu 3 dni zdjęcia w pełnej rozdzielczości są gotowe i przesłane w wersji elektroniczne na wskazany adres e-mail.<br><br>Osoby zainteresowane proszę o kontakt drogą mailową na stronie, na skrzynkę odbiorcza facebook Moto.Kadr lub kontakt telefoniczny pod numer 664 466 684.',
        paragraphs: [
          {
            title: "Cennik",
            content: `1 zdjęcie - 22,00 zł<br>
          2 zdjęcia - 35,00 zł<br>
          3 zdjęcia - 40,00 zł<br>
          4 zdjęcia - 45,00 zł<br>
          5 zdjęć - 50,00 zł<br>
          6 zdjęć - 60,00 zł<br>
          7 zdjęć - 70,00 zł<br>
          8 zdjęć - 80,00 zł<br>
          9 zdjęć - 90,00 zł<br>
          10 zdjęć - 100,00 zł<br>
          11 zdjęć - 107,00 zł<br>
          12 zdjęć - 114,00 zł<br>
          13 zdjęć - 121,00 zł<br>
          14 zdjęć - 128,00 zł<br>
          15 zdjęć - 135,00 zł<br>
          16 zdjęć - 142,00 zł<br>
          17 zdjęć - 149,00 zł<br>
          18 zdjęć - 156,00 zł<br>
          19 zdjęć - 163,00 zł<br>
          20 zdjęć - 170,00 zł<br>
          Powyżej 20 zdjęć cena do negocjacji.<br><br>`,
          },
          {
            title: "Sesje indywidualne",
            content: `Zawodnicy lub osoby ich reprezentujące, mogą zamówić sesję indywidualną z każdego startu na danych zawodach. Wówczas skupiam się na danym zawodniku i fotografuje każdy jago start i przejazd.<br>
          CENA ZA TAKĄ SESJĘ JEST USTALANA INDYWIDUALNIE Z KAŻDYM KLIENTEM, W ZALEŻNOŚCI OD LICZBY ZDJĘĆ.<br>
          CENA ZA FOTOREPORTAŻ Z CAŁEJ IMPREZY JEST USTALANA INDYWIDUALNIE Z KAŻDYM KLIENTEM, W ZALEŻNOŚCI LICZBY ZDJĘĆ I CZASU TRWANIA SESJI.<br>
          Zdjęcia poddawane są obróbce w programie graficznym (poprawa kolorów, balansu bieli, kontrast, kadrowanie itp) W ciągu 3 dni zdjęcia w pełnej rozdzielczości są gotowe i przesłane w wersji elektroniczne na wskazany adres e-mail.<br><br>
          Osoby zainteresowane proszę o kontakt drogą mailową na stronie, na skrzynkę odbiorcza facebook Moto.Kadr lub kontakt telefoniczny pod numer 664 466 684.`,
          },
        ],
      },
      imageUrl: "./assets/fotografia-sportowa.jpg",
      galleryUrls: [
        "./assets/sportowa/1J4A0404.jpg",
        "./assets/sportowa/1J4A2122.jpg",
        "./assets/sportowa/1J4A2299.jpg",
        "./assets/sportowa/1J4A2377.jpg",
        "./assets/sportowa/1J4A7191.jpg",
        "./assets/sportowa/1J4A7779.jpg",
        "./assets/sportowa/1J4A7793.jpg",
        "./assets/sportowa/1J4A8674.jpg",
        "./assets/sportowa/1J4A9310.jpg",
        "./assets/sportowa/batch_1J4A4944.jpg",
        "./assets/sportowa/batch_1J4A4986.jpg",
        "./assets/sportowa/batch_1J4A5007.jpg",
        "./assets/sportowa/batch_1J4A5058.jpg",
        "./assets/sportowa/batch_DSCF0604.jpg",
        "./assets/sportowa/batch_DSCF0623.jpg",
        "./assets/sportowa/DSCF1328.jpg",
        "./assets/sportowa/DSCF1346.jpg",
        "./assets/sportowa/DSCF1411.jpg",
      ],
      description:
        "Proponuję ciekawe zdjęcia sportowe wykonane profesjonalnym sprzętem fotograficznym. Oferta jest skierowana do organizatorów imprez i zawodów sportowych, zawodników, uczestników i ich rodzin oraz fanów. <br><br>Sporty motorowe i jeździeckie są dla mnie wyjątkowym wyzwaniem. Szczególnie jeździectwo plus fotografia to dwie pasje które mi zawsze towarzyszyły. Wieloletni kontakt z jeździectwem i końmi dziś procentuje w pracy przy sesjach fotograficznych. <br><br>Każda nowa sesja to wyzwanie które traktuje indywidualnie i podchodzę do jej realizacji z całkowitym zaangażowaniem. <br><br>Oferuję profesjonalne zdjęcia w dużej rozdzielczości w wersji elektronicznej.",
      text:
        "Proponuję ciekawe zdjęcia sportowe wykonane profesjonalnym sprzętem fotograficznym. Oferta jest skierowana do organizatorów imprez i zawodów sportowych, zawodników...",
    },
    {
      title: "Wnętrz",
      route: "oferta/fotografia-wnętrz",
      pricing: {
        title: "Fotografia wnętrz",
        text: "",
        paragraphs: [
          {
            content: `Cena - 400 zł za zdjęcia w wersji elektronicznej lokalu - mieszkanie do pięciu pomieszczeń. Komplet zdjęć w dużej rozdzielczości i drugi komplet zdjęć w pomniejszonej rozdzielczości przygotowany do internetu.<br>
          Czas sesji około 2 godzin mojej pracy na miejscu zlecenia.<br>
          Możliwość zamówienia i zakupu dodatkowych zdjęć.<br>
          Dojazd na miejsce sesji w okolicach Jeleniej Góry do 30 km bezpłatny. Powyżej 30 km cena 1 zł za kolejny kilometr.<br>
          Zdjęcia poddawane są obróbce w programie graficznym (poprawa kolorów, balansu bieli, kontrast, kadrowanie itp)<br>W ciągu 3 dni gotowe zdjęcia są przesyłane klientowi w wersji elektronicznej na wskazany adres e-mail.<br><br>
          Osoby zainteresowane proszę o kontakt drogą mailową na stronie, na skrzynkę odbiorcza facebook Moto.Kadr lub kontakt telefoniczny pod numer 664 466 684.`,
          },
        ],
      },
      imageUrl: "./assets/fotografia-wnetrz.jpg",
      galleryUrls: [
        "./assets/wnetrza/0J4A0515-HDR.jpg",
        "./assets/wnetrza/1J4A0305-HDR.jpg",
        "./assets/wnetrza/1J4A0313-HDR.jpg",
        "./assets/wnetrza/1J4A0378-HDR-3.jpg",
        "./assets/wnetrza/1J4A0385-HDR.jpg",
        "./assets/wnetrza/1J4A0392-HDR.jpg",
        "./assets/wnetrza/1J4A0541-HDR.jpg",
        "./assets/wnetrza/1J4A0563-HDR.jpg",
        "./assets/wnetrza/1J4A0564-HDR.jpg",
        "./assets/wnetrza/1J4A0565-HDR.jpg",
        "./assets/wnetrza/1J4A0577-HDR.jpg",
        "./assets/wnetrza/1J4A0586-HDR.jpg",
        "./assets/wnetrza/1J4A0601-HDR.jpg",
        "./assets/wnetrza/1J4A1246-HDR.jpg",
        "./assets/wnetrza/1J4A1253-HDR.jpg",
        "./assets/wnetrza/1J4A1283-HDR.jpg",
        "./assets/wnetrza/1J4A1297-HDR.jpg",
        "./assets/wnetrza/1J4A1298-HDR.jpg",
        "./assets/wnetrza/1J4A1303-HDR.jpg",
        "./assets/wnetrza/1J4A1311-HDR.jpg",
        "./assets/wnetrza/1J4A1324-HDR.jpg",
        "./assets/wnetrza/1J4A1332-HDR.jpg",
        "./assets/wnetrza/1J4A1341-HDR.jpg",
        "./assets/wnetrza/1J4A1493-HDR.jpg",
        "./assets/wnetrza/1J4A1516-HDR.jpg",
        "./assets/wnetrza/1J4A1524-HDR.jpg",
        "./assets/wnetrza/1J4A1545-HDR.jpg",
        "./assets/wnetrza/1J4A1556.jpg",
        "./assets/wnetrza/1J4A1557-HDR.jpg",
        "./assets/wnetrza/1J4A1562-HDR.jpg",
        "./assets/wnetrza/1J4A1599-HDR-2.jpg",
        "./assets/wnetrza/1J4A1602-HDR-2.jpg",
        "./assets/wnetrza/1J4A1613-HDR.jpg",
        "./assets/wnetrza/DSCF4667-HDR.jpg",
      ],
      description:
        "Profesjonalne zdjęcia mają duże znaczenie dla sprzedaży czy wynajmu nieruchomości. Oferuje Państwu wiedzę i doświadczenie z zakresu fotografii wnętrz oraz profesjonalny sprzęt fotograficzny. Zdjęcia nieruchomości na sprzedaż i do wynajmu : <br>- domów, mieszkań, apartamentów, pensjonatów i obiektów hotelowych oraz pomieszczeń biurowych, <br>- zdjęcia lokali gastronomicznych np. na portale społecznościowe.",
      text:
        "Profesjonalne zdjęcia mają duże znaczenie dla sprzedaży czy wynajmu nieruchomości. Oferuje Państwu wiedzę i doświadczenie z zakresu fotografii wnętrz oraz profesjonalny sprzęt fotograficzny...",
    },
    {
      title: "Zwierząt",
      route: "oferta/fotografia-zwierzat",
      pricing: null,
      imageUrl: "./assets/zwierzeta/IP5A4649.jpg",
      galleryUrls: [
        "./assets/zwierzeta/IMG_7251.jpg",
        "./assets/zwierzeta/IP5A4345.jpg",
        "./assets/zwierzeta/IP5A4554.jpg",
        "./assets/zwierzeta/IP5A4564.jpg",
        "./assets/zwierzeta/IP5A4636.jpg",
        "./assets/zwierzeta/IP5A4649.jpg",
        "./assets/zwierzeta/IP5A4726.jpg",
        "./assets/zwierzeta/IP5A4859.jpg",
        "./assets/zwierzeta/IP5A4947.jpg",
        "./assets/zwierzeta/IP5A6702.jpg",
        "./assets/zwierzeta/IP5A6737.jpg",
        "./assets/zwierzeta/IP5A6784.jpg",
        "./assets/zwierzeta/IP5A6824.jpg",
        "./assets/zwierzeta/IP5A7079.jpg",
        "./assets/zwierzeta/IP5A7919.jpg",
        "./assets/zwierzeta/IP5A9970.jpg",
      ],
      description: "",
      text: "",
    },
  ],
  upComingEvents: [
    {
      title: "MOTO-JAKUSZYCE",
      date: "11-12.09.2021",
      text:
        'W nadchodzący weekend w godzinach 11.00 - 17.00 na drodze krajowej nr 3 między Szklarską Porębą a Jakuszycami, zapraszam motocyklistów na sesję fotograficzną. Staram się uchwycić w kadrze każdy przejeżdżający motocykl. „MASZ OCHOTĘ NA FAJNĄ FOTKĘ - PODJEDŹ I POWIEDZ, ALBO DAJ SYGNAŁ KLAKSONEM I PRZEJEDŹ KILKA RAZY !!!"',
    },
  ],
  sessions: [],
};

const getters = {
  getEvents2025: (state) => state.events2025,
  getEvents2026: (state) => state.events2026,
  getOffer: (state) => state.offer,
  getUpComingEvents: (state) => state.upComingEvents,
  getSessions: (state) => state.sessions,
};

const actions = {
  async fetchEvents2025({ commit }) {
    let events = [];
    const res = await getDocs(
      query(collection(db, "sessions"), where("timestamp", ">", new Date(2025, 0, 0, 0, 0, 0, 0)))
    );
    res.forEach((doc) => {
      events.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    commit("SET_2025_EVENTS", events);
  },
  async fetchEvents2026({ commit }) {
    let events = [];
    const res = await getDocs(
      query(collection(db, "sessions"), where("timestamp", ">", new Date(2026, 0, 0, 0, 0, 0, 0)))
    );
    res.forEach((doc) => {
      events.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    commit("SET_2026_EVENTS", events);
  },
  async subscribeSessions({ commit }) {
    onSnapshot(query(collection(db, "sessions"), orderBy("timestamp", "desc")), (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === "added") {
          const session = {
            id: change.doc.id,
            ...change.doc.data(),
          };
          commit("ADD_SESSION", session);
        }
        if (change.type === "modified") {
          const session = {
            id: change.doc.id,
            ...change.doc.data(),
          };
          commit("EDIT_SESSION", session);
        }
        if (change.type === "removed") {
          commit("REMOVE_SESSION", change.doc.id);
        }
      });
    });
  },
  async fetchUpComingEvents({ commit }) {
    let events = [];
    const res = await getDocs(query(collection(db, "upComingEvents"), where("visible", "==", true)));
    res.forEach((doc) => {
      events.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    commit("SET_UPCOMING_EVENTS", events);
  },
  async changeUpComingEvent({ commit }, newEvent) {
    await updateDoc(doc(db, "upComingEvents", newEvent.id), {
      text: newEvent.text,
      date: newEvent.date,
      title: newEvent.title,
    });
    commit("SET_2021_EVENTS", [
      {
        ...newEvent,
      },
    ]);
  },
  async addSession({ dispatch }, newSession) {
    const dateFormatted = `${newSession.date.slice(8, 10)}-${newSession.date.slice(5, 7)}-${newSession.date.slice(
      0,
      4
    )}`;
    const photoRef = ref(sessionsRef, newSession.file.name);
    try {
      const uploadTask = await uploadBytes(photoRef, newSession.file);
      const downloadURL = await getDownloadURL(uploadTask.ref);
      await addDoc(collection(db, "sessions"), {
        title: newSession.title,
        downloadUrl: downloadURL,
        date: dateFormatted,
        galleryUrls: newSession.galleryUrls,
        timestamp: new Date(newSession.date),
      });
      return true;
    } catch (error) {
      console.error(error);
      dispatch("showAlert");
      return false;
    }
  },
  async deleteSession({ dispatch }, sessionId) {
    await deleteDoc(doc(db, "sessions", sessionId));
    dispatch("showAlert");
  },
  showAlert() {},
};

const mutations = {
  SET_2025_EVENTS: (state, data) => (state.events2025 = data),
  SET_2026_EVENTS: (state, data) => (state.events2026 = data),
  SET_UPCOMING_EVENTS: (state, data) => (state.upComingEvents = data),
  ADD_SESSION: (state, data) => state.sessions.push(data),
  REMOVE_SESSION: (state, id) => (state.sessions = state.sessions.filter((v) => v.id !== id)),
  EDIT_SESSION: (state, data) => (state.sessions = state.sessions.map((obj) => (obj.id === data.id ? data : obj))),
  EDIT_UPCOMING_EVENT: (state, data) => (state.upComingEvents[0] = data),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
